// Shared by every form that records money settled by hand: the order-level
// payment status, and the per-payment `mark-paid` on an adjustment charge. The
// two endpoints take the same field names on purpose, so they take the same
// constants here too.

// The backend accepts any of these, but every manual payment recorded today is a
// bank transfer — so the forms lock to the first one and don't ask. Show the
// field again when a second method actually turns up.
export const PAYMENT_METHOD_OPTIONS = [
	"BANK_TRANSFER",
	"E_WALLET",
	"QRIS",
	"CASH",
	"CREDIT_CARD",
	"MANUAL",
] as const;
export const PAYMENT_METHOD = PAYMENT_METHOD_OPTIONS[0];

// Company accounts that receive manual payments. Picking one fills both
// `bank_code` and `payment_destination` from here, so an admin can't mistype
// either half of a pair.
export const COMPANY_BANK_ACCOUNTS = [
	{
		bankCode: "BCA",
		accountNumber: "4210393922",
		accountName: "PT Revolusi Kesehatan Indonesia",
	},
] as const;

// Picked when the money went somewhere not on the list above; the two fields are
// then typed by hand.
export const OTHER_BANK_ACCOUNT = "OTHER";

// Prefilled when a listed account is picked, so the admin edits a sentence
// instead of writing one. "Other" clears both — we don't know the account.
export const prefillFromAccount = (
	account?: (typeof COMPANY_BANK_ACCOUNTS)[number],
) => ({
	description: account
		? `Transfer langsung ke rekening perusahaan ${account.bankCode} a.n. ${account.accountName}`
		: "",
	notes: account ? `ref. ${account.accountNumber}, dicek oleh Finance` : "",
});

// The pair a listed account fills in; "Other" leaves whatever was typed.
export const destinationFromAccount = (accountNumber: string) => {
	const account = COMPANY_BANK_ACCOUNTS.find(
		(item) => item.accountNumber === accountNumber,
	);

	return account
		? {
				bank_code: account.bankCode,
				payment_destination: account.accountNumber,
			}
		: {};
};
